function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M5.55632 1.09074H9.89598L5.39098 14.4386C5.34468 14.5757 5.25653 14.6949 5.13894 14.7794C5.02135 14.8638 4.88025 14.9092 4.73548 14.9092H1.35815C1.24847 14.9093 1.14036 14.8832 1.04277 14.8331C0.945175 14.783 0.860906 14.7105 0.796929 14.6214C0.732953 14.5323 0.691109 14.4292 0.67486 14.3208C0.65861 14.2123 0.668422 14.1015 0.703483 13.9976L4.90065 1.56141C4.94693 1.42419 5.0351 1.30495 5.15272 1.22049C5.27035 1.13602 5.41151 1.09058 5.55632 1.09058V1.09074Z",
  fill: "url(#paint0_linear_2447_66565)"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M11.8625 10.0435H4.98084C4.91686 10.0434 4.85434 10.0626 4.80143 10.0986C4.74852 10.1345 4.70767 10.1856 4.6842 10.2451C4.66072 10.3046 4.65572 10.3698 4.66984 10.4322C4.68395 10.4946 4.71654 10.5513 4.76334 10.595L9.18534 14.7223C9.31409 14.8424 9.48361 14.9092 9.65967 14.9091H13.5563L11.8625 10.0435Z",
  fill: "#0078D4"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M5.55635 1.09058C5.40996 1.09002 5.26722 1.13628 5.14899 1.22261C5.03076 1.30893 4.94323 1.4308 4.89918 1.57041L0.708683 13.9861C0.671263 14.0904 0.659515 14.2022 0.674433 14.312C0.689351 14.4218 0.730496 14.5264 0.794388 14.6169C0.858279 14.7075 0.943038 14.7813 1.04149 14.8321C1.13995 14.883 1.2492 14.9094 1.36002 14.9091H4.82452C4.95355 14.886 5.07415 14.8291 5.174 14.7442C5.27385 14.6593 5.34937 14.5494 5.39285 14.4257L6.22852 11.9629L9.21352 14.7471C9.3386 14.8505 9.49552 14.9078 9.65785 14.9091H13.54L11.8374 10.0434L6.87385 10.0446L9.91168 1.09058H5.55635Z",
  fill: "url(#paint1_linear_2447_66565)"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M11.0991 1.56058C11.0529 1.42358 10.9649 1.30454 10.8474 1.22022C10.73 1.1359 10.5891 1.09056 10.4445 1.09058H5.60797C5.75255 1.09058 5.89348 1.13594 6.01092 1.22025C6.12836 1.30457 6.2164 1.4236 6.26264 1.56058L10.46 13.9972C10.4951 14.1012 10.5049 14.212 10.4887 14.3205C10.4724 14.429 10.4306 14.5321 10.3666 14.6212C10.3026 14.7103 10.2184 14.7829 10.1208 14.833C10.0231 14.8831 9.91501 14.9092 9.80531 14.9092H14.642C14.7517 14.9092 14.8598 14.8831 14.9574 14.833C15.0549 14.7829 15.1392 14.7102 15.2032 14.6211C15.2671 14.532 15.3089 14.4289 15.3252 14.3205C15.3414 14.212 15.3316 14.1012 15.2965 13.9972L11.0991 1.56058Z",
  fill: "url(#paint2_linear_2447_66565)"
});

var _ref5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_2447_66565",
  x1: 7.13798,
  y1: 2.11474,
  x2: 2.63115,
  y2: 15.4291,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#114A8B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#0669BC"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear_2447_66565",
  x1: 8.54585,
  y1: 8.31941,
  x2: 7.50335,
  y2: 8.67191,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopOpacity: 0.3
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.071,
  stopOpacity: 0.2
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.321,
  stopOpacity: 0.1
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.623,
  stopOpacity: 0.05
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint2_linear_2447_66565",
  x1: 7.97247,
  y1: 1.72624,
  x2: 12.9196,
  y2: 14.9064,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#3CCBF4"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#2892DF"
})));

const SvgAzureALogo = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref, _ref2, _ref3, _ref4, _ref5);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgAzureALogo, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/azure-a-logo.dc4367e1.svg";
export { ForwardRef as ReactComponent };